/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_FooterInputs */

const da_forside_footer = /** @type {(inputs: Forside_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AImforA er et støtteværktøj til terminsprøver. Det må ikke bruges til den officielle bedømmelse af folkeskolens prøver.`)
};

/** @type {(inputs: Forside_FooterInputs) => LocalizedString} */
const en_forside_footer = da_forside_footer;

/**

* @param {Forside_FooterInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_footer = /** @type {((inputs?: Forside_FooterInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_FooterInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_footer(inputs)
	return /** @type {LocalizedString} */ ("AImforA er et støtteværktøj til terminsprøver. Det må ikke bruges til den officielle bedømmelse af folkeskolens prøver.")
});